import React from "react";
import clicksims from "../../../assets/img/clicksims.png";
import { Image } from "react-bootstrap";

const SuccessPage = () => {
  return (
    <div className="success-container">
      <Image src={clicksims} width={300} height={300} />
    </div>
  );
};

export default SuccessPage;
